import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Thumbnail } from 'react-bootstrap';

import FlightDates from '../flightDates/FlightDates';
import FlightGrid from '../flightGrid/FlightGrid';
import Filters from '../filters/Filters';

import './FlightOptions.css';
import FeatureService from '../../../services/feature/FeatureService';
import Features from '../../../const/Features';
import GifPlaneLoader from './gifPlaneLoader/GifPlaneLoader';

const I18n = require('i18n-react').default;

const propTypes = {
  id: PropTypes.string.isRequired,
  isDeparture: PropTypes.bool.isRequired,
  origin: PropTypes.string.isRequired,
  finalDestination: PropTypes.string.isRequired,
  originAirportName: PropTypes.string,
  finalDestinationAirportName: PropTypes.string,
  flights: PropTypes.arrayOf(
    PropTypes.shape({
      originAirport: PropTypes.string.isRequired,
      originAirportName: PropTypes.string.isRequired,
      finalDestination: PropTypes.string.isRequired,
      finalDestinationName: PropTypes.string.isRequired,
      departureDate: PropTypes.string,
      departureTime: PropTypes.string.isRequired,
      finalArrivalDate: PropTypes.string,
      finalArrivalTime: PropTypes.string.isRequired,
      dateVariation: PropTypes.number.isRequired,
      elapsedFlightTime: PropTypes.string,
      firstFlightNumber: PropTypes.number.isRequired,
      operatingCarriers: PropTypes.array.isRequired,
      prices: PropTypes.arrayOf(
        PropTypes.shape({
          category: PropTypes.string.isRequired,
          passenger: PropTypes.string,
          value: PropTypes.number,
          currency: PropTypes.string
        })
      ),
      baggage: PropTypes.arrayOf(
        PropTypes.shape({
          category: PropTypes.string.isRequired,
          quantity: PropTypes.number,
          weight: PropTypes.number
        })
      ),
      connection: PropTypes.number.isRequired,
      hasExchangeAirport: PropTypes.bool.isRequired,
      throughFlight: PropTypes.number.isRequired,
      returnFlights: PropTypes.arrayOf(PropTypes.object),
      flightGroup: PropTypes.arrayOf(PropTypes.object)
    })
  ).isRequired,
  date: PropTypes.string.isRequired,
  filterDepartureDate: PropTypes.string.isRequired,
  filterReturnDate: PropTypes.string,
  onClick: PropTypes.func,
  callback: PropTypes.func,
  callbackAlterSearch: PropTypes.func,
  isLoading: PropTypes.bool,
  manyDepartureFlightOptions: PropTypes.bool,
  toogleElapsedFlightTime: PropTypes.bool,
  toggleDetailsModal: PropTypes.bool,
  filterCabinCategory: PropTypes.string,
  isCallcenterEnabled: PropTypes.bool,
  numPagination: PropTypes.number
};

const defaultProps = {
  isDeparture: true,
  flights: [],
  originAirportName: null,
  finalDestinationAirportName: null,
  isLoading: false,
  toogleElapsedFlightTime: false,
  toggleDetailsModal: false,
  filterCabinCategory: 'ECONOMY'
};

class FlightOptions extends React.Component {
  constructor() {
    super();

    this.state = {
      featureShowModalSelectionFlightsToggle: false,
      featureFilterFlightsAfterSearch: false,
      isLoading: true
    };
  }

  componentWillMount() {
    FeatureService.isFeatureEnabled(Features.SHOW_MODAL_SELECTION_FLIGHTS).then(isEnabledModal => {
      this.setState({
        featureShowModalSelectionFlightsToggle: isEnabledModal,
        isLoading: false
      });
    });

    FeatureService.isFeatureEnabled(Features.FILTER_FLIGHTS_AFTER_SEARCH).then(isEnableFilter => {
      if (isEnableFilter) {
        this.setState({
          featureFilterFlightsAfterSearch: isEnableFilter
        });
      }
    });
  }

  buildAirportName(simbol, airportName) {
    const airportNameBuilder = [];
    if (airportName) {
      airportNameBuilder.push(airportName);
    }
    airportNameBuilder.push('(' + simbol + ')');
    return airportNameBuilder.join(' ');
  }

  renderHeader() {
    if (this.props.isDeparture) {
      return (
        <div>
          <span>{I18n.translate('components.flightOptions.selectDepatureFlight')}</span>
        </div>
      );
    }
    return (
      <div>
        <span>{I18n.translate('components.flightOptions.selectReturnFlight')}</span>
      </div>
    );
  }

  renderButtonLoading() {
    return (
      <div>
        <div className="flightOptions__planeGif" span={24}>
          <GifPlaneLoader src="../styles/img/planeLoader_BF.gif" alt="" />
        </div>
        <div className="flightOptions flightOptions__gifInfo" span={24}>
          <span>{I18n.translate('components.flightOptions.searchingFlightsGifInfo')}</span>
        </div>
        <div className="flightOptions flightOptions__info" span={24}>
          <span>{I18n.translate('components.flightOptions.searchingFlightsInfo')}</span>
        </div>
      </div>
    );
  }

  renderFlights() {
    if (
      (this.props.isLoading === true || this.state.isLoading) &&
      (this.props.isDeparture ? this.props.numPagination === 1 : true)
    ) {
      return this.renderButtonLoading();
    } else {
      return (
        <div>
          <Row>
            <Col md={12}>
              <FlightGrid
                id={this.props.id + '-flightGrid'}
                flights={this.props.flights}
                callback={this.props.callback}
                callbackAlterSearch={this.props.callbackAlterSearch}
                filterDepartureDate={this.props.filterDepartureDate}
                filterReturnDate={this.props.filterReturnDate}
                manyDepartureFlightOptions={this.props.manyDepartureFlightOptions}
                toogleElapsedFlightTime={this.props.toogleElapsedFlightTime}
                toggleDetailsModal={this.props.toggleDetailsModal}
                isDeparture={this.props.isDeparture}
                featureShowModalSelectionFlightsToggle={
                  this.state.featureShowModalSelectionFlightsToggle
                }
                filterCabinCategory={this.props.filterCabinCategory}
                ref={c => {
                  this.flightGrid = c;
                }}
                isCallcenterEnabled={this.props.isCallcenterEnabled}
              />
            </Col>
          </Row>
        </div>
      );
    }
  }

  renderFilters() {
    if (this.state.featureFilterFlightsAfterSearch) {
      return (
        <Filters
          flights={this.props.flights}
          filteredList={this.props.filteredList}
          updateFilters={this.props.updateFilters}
          auxFlights={this.props.auxFlights}
          clearFilters={this.props.clearFilters}
          flightType={this.props.flightType}
        />
      );
    }
  }

  render() {
    return (
      <div id={`componentFlightOptions-${this.props.id}`} className="flightOptions">
        <Row className="header">
          <Col md={12} className="flight-title collapsedFixedTitle">
            {this.renderHeader()}
          </Col>
        </Row>
        <Row>
          <Col md={12} className="flight-description">
            <span className="airport-description" id="lblDepartureAirport">
              {this.buildAirportName(this.props.origin, this.props.originAirportName)}
            </span>
            &nbsp;
            {I18n.translate('components.flightOptions.to')}
            &nbsp;
            <span className="airport-description" id="lblReturnAirport">
              {this.buildAirportName(
                this.props.finalDestination,
                this.props.finalDestinationAirportName
              )}
            </span>
          </Col>
        </Row>
        <Row>{this.renderFilters()}</Row>
        <Row className="flightDates">
          <Col md={12}>
            <FlightDates
              id={this.props.id + '-flightDate'}
              date={this.props.date}
              onClick={this.props.onClick}
              ref={c => {
                this.flightDate = c;
              }}
            />
          </Col>
        </Row>
        {this.renderFlights()}
      </div>
    );
  }
}

FlightOptions.propTypes = propTypes;
FlightOptions.defaultProps = defaultProps;

export default FlightOptions;



// WEBPACK FOOTER //
// ./src/components/flightSelection/flightOptions/FlightOptions.jsx